import * as Sentry from '@sentry/vue';

export default {
  state: {
    defaultTenant: null,
    tenant: null,
    tenantToken: null,
    tenants: [],
  },
  mutations: {
    RESET_TENANT(state) {
      state.defaultTenant = null;
      state.tenant = null;
      state.tenants = [];
    },
    SET_DEFAULT_TENANT(state, tenant) {
      state.defaultTenant = tenant;
    },
    SET_TENANT_TOKEN(state, token) {
      state.tenantToken = token;
    },
    SET_TENANT(state, tenant) {
      state.tenant = tenant;
      if (SENTRY_ENABLED) {
        const userInfo = Sentry.getCurrentScope().getUser() || {};
        userInfo.tenantId = tenant.id;
        userInfo.tenantName = tenant.name;
        Sentry.setUser(userInfo);
      }
    },
    SET_TENANTS(state, tenants) {
      tenants.sort((a, b) => {
        if (a.display_name < b.display_name) {
          return -1;
        }
        if (a.display_name > b.display_name) {
          return 1;
        }
        return 0;
      });
      state.tenants = tenants;
    },
  },
  actions: {
    resetTenant({ state, commit, rootGetters }) {
      if (state.tenant && rootGetters.configAuth === 'authv2') {
        commit('SET_TENANT_TOKEN', null);
      }
      commit('RESET_TENANT');
    },
    setDefaultTenant({ commit }, tenant) {
      commit('SET_DEFAULT_TENANT', tenant);
    },
    setTenant({ commit }, tenant) {
      commit('SET_TENANT', tenant);
    },
    setTenantToken({ commit }, token) {
      commit('SET_TENANT_TOKEN', token);
    },
    setTenants({ commit }, tenants) {
      commit('SET_TENANTS', tenants);
    },
  },
  getters: {
    defaultTenant: (state) => state.defaultTenant,
    domainTenant: (state, getters) => {
      let domainTenant;
      if (state.tenants.length > 0 && getters.user) {
        const userDomain = getters.user.email.split('@')[1];
        domainTenant = state.tenants.find((t) => t.domain && t.domain.includes(userDomain));
      }
      return domainTenant;
    },
    tenant: (state) => state.tenant,
    tenantToken: (state) => state.tenantToken,
    tenants: (state) => state.tenants,
  },
};
